'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialSnapchat = function IoSocialSnapchat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.5 28.1c0 0.2 0 0.9-0.5 1.7-0.4 0.6-1.2 1.5-2.9 1.8-0.5 0.1-0.9 0.3-1.2 0.4-0.2 0-0.4 0-0.6 0v0.1c0 0.6 0 1-0.3 1.4-0.1 0.4-0.7 1-1.7 1-0.1 0-0.5 0-0.7-0.1-0.1 0-0.2-0.1-0.4-0.1-0.5-0.1-1.2-0.2-1.8-0.2-0.8 0-1.5 0.2-2 0.5-0.3 0.2-0.7 0.6-1.1 0.8-1.4 1-3 2.1-5.6 2.1s-4.1-1.1-5.5-2.1c-0.4-0.2-0.7-0.6-1.1-0.8-0.5-0.3-1.2-0.5-1.9-0.5-0.7 0-1.4 0.1-1.9 0.2-0.2 0-0.3 0.1-0.4 0.1-0.2 0.1-0.6 0.1-0.7 0.1-1 0-1.6-0.6-1.7-1-0.3-0.4-0.3-0.8-0.3-1.4v-0.1c-0.2 0-0.4 0-0.5 0-0.3-0.1-0.8-0.3-1.3-0.4-1.7-0.3-2.5-1.2-2.9-1.8-0.5-0.8-0.5-1.4-0.5-1.6v-1.2l1.2 0c1.2-0.1 3.4-0.6 4.2-1.4 2.3-2.1 2.8-3.3 2.8-4 0-0.1 0-0.2-0.3-0.4-0.4-0.3-1-0.5-1.6-0.7-0.4-0.1-0.8-0.2-1.1-0.3-0.7-0.4-1.4-1.3-1.3-2.3 0.1-1.2 1.1-2.1 2.3-2.1 0.4 0 0.7 0 1 0.1 0.6 0.3 1 0.3 1.3 0.4-0.1-0.7-0.1-1.5-0.2-2.3-0.4-3 0.4-5.8 2.2-8 2-2.3 5-3.5 8.2-3.5 3.2 0 6.3 1.2 8.2 3.5 1.9 2.2 2.7 4.9 2.3 7.9-0.1 0.9-0.1 1.7-0.2 2.4 0.3-0.1 0.8-0.1 1.4-0.4 0.3 0 0.6-0.1 0.9-0.1 1.3 0 2.3 0.9 2.4 2.1 0 1-0.7 1.9-1.4 2.3-0.3 0.1-0.7 0.2-1.1 0.3-0.6 0.2-1.1 0.4-1.5 0.7-0.3 0.2-0.4 0.3-0.4 0.4 0 1.2 1.6 2.9 2.8 4 0.9 0.8 3.1 1.3 4.2 1.4l1.2 0v1.1z m-22.5-18.1c-0.7 0-1.2 0.9-1.2 1.9s0.5 1.9 1.2 1.9 1.3-0.9 1.3-1.9-0.6-1.9-1.3-1.9z m8.1 6.1c0.3-0.2 0.3-0.7 0-0.9s-0.7-0.3-0.9 0c-1 0.9-2.2 1.4-3.5 1.4-1.3 0-2.5-0.5-3.4-1.4-0.2-0.3-0.7-0.3-0.9 0s-0.3 0.7 0 0.9c1.1 1.2 2.7 1.8 4.3 1.8s3.2-0.6 4.4-1.8z m-0.6-2.3c0.7 0 1.3-0.9 1.3-1.9s-0.6-1.9-1.3-1.9-1.2 0.9-1.2 1.9 0.5 1.9 1.2 1.9z' })
        )
    );
};

exports.default = IoSocialSnapchat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-snapchat.js
// module id = 2501
// module chunks = 0